interface FieldProps {
  label: string
  description?: string
  children: React.ReactNode
}

// TailAdmin Label.tsx: mb-1.5 text-sm font-medium gray-700; hint text mt-1.5 text-xs gray-500.
// A trailing " *" (how callers mark a required field) renders as TailAdmin's error-500 asterisk.
export function Field({ label, description, children }: FieldProps) {
  const required = label.endsWith(' *')
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-gray-700">
        {required ? label.slice(0, -2) : label}
        {required && <span className="text-error-500"> *</span>}
      </label>
      {children}
      {description && <p className="mt-1.5 text-xs text-gray-500">{description}</p>}
    </div>
  )
}
